// Libraries
import React from 'react';

// Supermove
import DataLoader from '@supermove/components/src/DataLoader';
import {gql, useQuery} from '@supermove/graphql';
import {useNavigationDOM, useToast} from '@supermove/hooks';
import {OrganizationModel, UserModel} from '@supermove/models';

// App
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import CalendarIntegrationForm from '@shared/modules/AccountCalendar/forms/CalendarIntegrationForm';
import useCreateCalendarIntegrationMutation from '@shared/modules/AccountCalendar/hooks/useCreateCalendarIntegrationMutation';
import CalendarIntegrationPage from 'modules/Organization/Settings/Communication/components/CalendarIntegrationPage';

const CreateCalendarIntegrationPageContent = ({
  organization,
}: {
  organization: OrganizationModel;
}) => {
  const {navigator} = useNavigationDOM();
  const createDocumentFlowSuccessToast = useToast({
    ToastComponent: SuccessToast,
  });

  const calendarIntegrationForm = CalendarIntegrationForm.new({organizationId: organization.id});

  const {form, submitting, handleSubmit} = useCreateCalendarIntegrationMutation({
    calendarIntegrationForm,
    onSuccess: (calendarIntegration) => {
      createDocumentFlowSuccessToast.handleToast({
        message: `Calendar integration created!`,
      });
      navigator.replace(`/settings/communication/calendar-integrations`);
    },
    onError: (errors: any) => console.log({errors}),
  });

  const field = 'calendarIntegrationForm';

  return (
    <CalendarIntegrationPage
      organization={organization}
      form={form}
      field={field}
      submitting={submitting}
      handleSubmit={handleSubmit}
      handleCancel={() => navigator.replace(`/settings/communication/calendar-integrations`)}
    />
  );
};

const CreateCalendarIntegrationPage = () => {
  const {data, loading} = useQuery<{viewer: UserModel}>(CreateCalendarIntegrationPage.query);

  return (
    <DataLoader data={data} loading={loading}>
      {({loadedData}) => (
        <CreateCalendarIntegrationPageContent
          organization={loadedData.viewer.viewingOrganization}
        />
      )}
    </DataLoader>
  );
};

CreateCalendarIntegrationPage.query = gql`
  ${CalendarIntegrationPage.fragment}

  query CreateCalendarIntegrationPage {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
        ...CalendarIntegrationPage
      }
    }
  }
`;

export default CreateCalendarIntegrationPage;
